export class AreaPoligono {
  path: Path2D;
  estate: any;
  estate_id: string;
  colorBorde: string;
  colorRelleno: string;
  ctx;
  imagenRef;
  vertices: { x: number; y: number }[];

  constructor(
    vertices: { x: number; y: number }[],
    estate_id: string,
    estate: any,
    colorBorde: string,
    colorRelleno: string,
    ctx: CanvasRenderingContext2D,
    imagenRef: any
  ) {
    this.imagenRef = imagenRef;
    this.vertices = vertices;
    this.estate_id = estate_id;
    this.estate = estate;
    this.path = this.crearPath(vertices);
    this.colorBorde = colorBorde;
    this.colorRelleno = colorRelleno;
    this.ctx = ctx; // Almacenar el contexto en la instancia del polígono
  }

  crearPath(vertices: { x: number; y: number }[]): Path2D {
    // Calcular escalas de conversión inversas
    const imagen = this.imagenRef.nativeElement;
    const escalaX = imagen.naturalWidth / imagen.width;
    const escalaY = imagen.naturalHeight / imagen.height;

    const path = new Path2D();

    path.moveTo(vertices[0].x / escalaX, vertices[0].y / escalaY);
    for (let i = 1; i < vertices.length; i++) {
      path.lineTo(vertices[i].x / escalaX, vertices[i].y / escalaY);
    }
    path.closePath();

    return path;
  }

  actualizarPath(vertices: { x: number; y: number }[]): void {
    this.path = this.crearPath(vertices);
  }

  dibujar(ctx: CanvasRenderingContext2D): void {
    ctx.strokeStyle = this.colorBorde; // Color del borde
    ctx.lineWidth = 3; // Ancho del borde
    ctx.fillStyle = this.colorRelleno;
    ctx.stroke(this.path);
    ctx.fill(this.path);
  }
  dibujarSeleccion(): void {
    console.log("AreaPoligono->dibujar", this.path);
    this.ctx.strokeStyle = "red"; // Color del borde
    this.ctx.lineWidth = 3; // Ancho del borde
    this.ctx.fillStyle = "yellow";
    this.ctx.stroke(this.path);
    this.ctx.fill(this.path);
  }

  verificarClick(x: number, y: number): boolean {
    return this.ctx.isPointInPath(this.path, x, y);
  }
}
